import React from "react";
import line from "../assets/line.png";
import First from "../assets/First.jpg";
import Eh from "../assets/Eh.png";
import EhrDraw from "./EhrDraw";
import EhrInfographics from "../assets/EhrInfographics.svg";
import EhrPath from "../assets/EhrPath.svg";
import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const EhrPage = () => {
  return (
    <div className="min-h-screen scroll-smooth">

      {/* =======================
          HERO SECTION 1024×580
      ======================== */}
 <section className="relative h-[50vh] sm:h-[60vh] flex items-center justify-center text-white overflow-hidden">
        <video
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          src="/Product780.mp4"
          autoPlay muted loop playsInline
        />

        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />

        <div
          className="
            max-w-7xl mx-auto px-4 sm:px-6 
            w-full z-20 
            h-[580px] flex flex-col items-center justify-center text-center
          "
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
            WISE EHR
          </h1>

        <h2
  className="
    uppercase font-extrabold
    text-white [@media(hover:hover)]:text-transparent
    text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl
    leading-snug sm:leading-tight
  "
  style={{
    fontFamily: "Calibri, sans-serif",
    WebkitTextStroke: "1.8px #ffffff",
    letterSpacing: "0.04em",
  }}
>
  Empowering Clinicians,
  <br className="sm:hidden" /> Enriching Care
</h2>
        </div>
      </section>

      {/* =======================
          VISION SECTION 1024×580
      ======================== */}
     <section
  className="
    w-[1024px] h-[580px]
    md:w-screen md:h-auto
    bg-white flex items-center justify-center
    px-4 sm:px-6
  "
>
  <div className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

    <p
  className="text-gray-700 text-sm sm:text-base md:text-[26px] text-justify mt-10"
  style={{ lineHeight: "1.5" }}
>
      <span className="font-bold text-gray-900">WISE EHR</span> transforms
      the way healthcare providers interact with patient data. Designed
      for accuracy, accessibility, and adaptability, it offers a unified
      view of medical history, treatments, diagnostics, and ongoing care.
      Built with clinical efficiency in mind, it bridges gaps between
      caregivers, systems, and patients—while maintaining full regulatory
      compliance.{" "}
      <span className="font-bold text-gray-900">WISE EHR</span> is a
      secure, intuitive, and interoperable platform designed to
      centralize patient health data, streamline clinical workflows, and
      enhance care coordination across departments.
    </p>

    <div className="flex justify-center mt-8">
  <img
    src={Eh}
    alt="EHR Illustration"
    className="max-w-[260px] md:max-w-[300px]"
  />
</div>


  </div>
</section>


      {/* =======================
          INFOGRAPHICS 1024×580
      ======================== */}
      <section
  className="
    w-[1024px] h-[570px]
    md:w-screen md:h-auto
    bg-white flex items-center justify-center
  "
>
  <img
  src={EhrInfographics}
  alt="EHR Infographics"
  className="w-full max-w-[700px] h-auto mb-8"
/>

</section>


      {/* =======================
          DRAW SECTION 1024×580
      ======================== */}
      <section
  className="
    w-[1024px] h-[580px]
    md:w-screen md:h-auto
    bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6]
    text-white flex items-center justify-center
    overflow-hidden relative
  "
>
  {/* FIXED HEIGHT WRAPPER */}
  <div className="w-full h-[580px] flex items-center justify-center overflow-hidden">

    {/* SCALE DRAW TO FIT */}
    <div className="h-full flex items-center justify-center">
      <div className="scale-[0.55] sm:scale-[0.65] md:scale-[0.85] lg:scale-100 origin-center">
        <EhrDraw />
      </div>
    </div>

  </div>
</section>


      <section
  className="
    snap-start
    w-[1024px] h-[580px]
    md:w-screen md:h-auto
    bg-white
    flex items-center justify-center
    overflow-hidden
  "
>
  <div className="w-full h-[580px] flex items-center justify-center overflow-hidden">
     <img 
    src={EhrPath} 
    alt="EHR Path" 
    className="max-w-5xl w-full h-auto object-contain"
  />
  </div>
</section>

      {/* =======================
          FOOTER (AUTO)
      ======================== */}
      <section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden h-auto">
        
        <div className="absolute top-[180px] left-0 w-full">
          <div className="bg-white rounded-t-[12rem] sm:rounded-t-[14rem] h-auto sm:h-[120vh] pb-10"></div>
        </div>

        <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-28 pb-16">
          <div className="text-center mt-[160px] mb-12">
            <h2 className="text-4xl sm:text-5xl font-bold text-[#6F7DFF]">
              Collaborate for Success
            </h2>
            <p className="text-gray-700 text-lg sm:text-xl">
              Working together fosters innovation and excellence.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">

            <div>
              <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
              <img src={ColourLogo} className="w-40 mb-4" />
              <p>Wissenstil Solutions drives digital innovation.</p>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
              <ul className="space-y-2">
                <li>Image Analysis</li>
                <li>Anomaly Detection</li>
                <li>Medical Coding</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
              <ul className="space-y-2">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Wise Services</Link></li>
                <li><Link to="/products">Wise Products</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-gray-900">CONTACT</h3>
              <p>Wissenstil Solutions Pvt Ltd<br />Whitefield, Bangalore</p>
              <div className="mt-4 space-y-3">
                <p className="flex items-center gap-2"><Phone /> +91 9986158307</p>
                <p className="flex items-center gap-2"><Mail /> Manish.palliyil@wissenstil.com</p>
              </div>
            </div>

          </div>
        </div>

      </section>

    </div>
  );
};

export default EhrPage;